module.exports = __webpack_public_path__ + "static/media/unbeatablevalue500-old.5eb53370.png";